import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=7bbdfd08&scoped=true"
import script from "./Tarjeta.vue?vue&type=script&lang=js"
export * from "./Tarjeta.vue?vue&type=script&lang=js"
import style0 from "./Tarjeta.vue?vue&type=style&index=0&id=7bbdfd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbdfd08",
  null
  
)

export default component.exports